

/** Auto scoll to target hashtag **/
const hash = window.location.hash;
const target = document.getElementById(hash.substring(1));

if (target){
    target.click();
}